import NotificationBanner from "./components/NotificationBanner/index.svelte";
import Navigation from "./components/Navigation/index.svelte";
import Slideshow from "./components/Slideshow/index.svelte";
import GeolocationPopup from "./components/GeolocationPopup/index.svelte";

(async function initialize() {
  const slideShowTarget = document.querySelector("[data-svelte=slideshow]");

  if (slideShowTarget) {
    new Slideshow({
      target: slideShowTarget,
      hydrate: false,
      props: {
        slides: JSON.parse(slideShowTarget.getAttribute("data-svelte-payload")),
      },
    });
  }

  const mainBannerTarget = document.querySelector("[data-svelte=main_banner]");
  if (mainBannerTarget) {
    new NotificationBanner({
      target: mainBannerTarget,
      hydrate: false,
      props: {
        settings: JSON.parse(mainBannerTarget.getAttribute("data-svelte-payload")),
      },
    });
  }

  const secondaryBannerTarget = document.querySelector("[data-svelte=secondary_banner]");
  if (secondaryBannerTarget) {
    new NotificationBanner({
      target: secondaryBannerTarget,
      hydrate: false,
      props: {
        settings: JSON.parse(secondaryBannerTarget.getAttribute("data-svelte-payload")),
      },
    });
  }

  const navigationAndSearchTarget = document.querySelector("[data-svelte=navigation]");
  if (navigationAndSearchTarget) {
    new Navigation({
      target: navigationAndSearchTarget,
      hydrate: false,
      props: {
        settings: JSON.parse(navigationAndSearchTarget.getAttribute("data-svelte-payload")),
      },
    });
  }

  const geolocationPopupTarget = document.querySelector("[data-svelte=geolocation-popup]");
  if (geolocationPopupTarget) {
    new GeolocationPopup({
      target: geolocationPopupTarget,
      hydrate: false,
      props: {
      }
    })
  }
})();

let app;
export default app;
